/* Easing
======================================== */
const
	ease    = $.bez([0.87, 0, 0.48, 1]),
	speed   = 600;

/* Heights
======================================== */
function heights(){
    document.documentElement.style.cssText = `
        --h:  ${window.innerHeight}px;
        --menu: ${$('#tb-menu').innerHeight()}px;
        --footer: ${$('#footer').innerHeight()}px;
    `;
}

/* Page-transitions
======================================== */
function transitions() {
    document.querySelectorAll('[data-transition]:not([target])').forEach(fader => {
        fader.addEventListener('click', event => {
            event.preventDefault();
            const href = fader.getAttribute('href');
            $('#loader').fadeIn(speed, () => (window.location.href = href));
        });
    });
    
    window.addEventListener('pageshow', event => {
        if (event.persisted) $('#loader').fadeOut(speed);
    });
}


/* Newsletter 
======================================== */
// $('#close-nl, #open-nl').on("click", function() {
//     $('dialog.newsletter-form').toggleClass('hidden');
// });

const
    $N = $('#newsletter'),
    $I = $('#email');
$N.submit(function(){
    setTimeout(function(){
        $I.val('THANK YOU!').blur().addClass('submited');
    }, 200);
});
$I.click(function(){
    if($I.hasClass('submited')){
        $I.removeClass('submited');
        $N[0].reset();
    }
});

/* Lazy Videos
======================================== */
document.addEventListener('lazybeforeunveil', function(e) {
    const video = e.target;
    if (video.tagName === 'VIDEO') {
        const sources = video.querySelectorAll('source');
        sources.forEach(source => {
            if (source.dataset.src) {
                source.src = source.dataset.src;
            }
        });
        
        if (video.dataset.autoplay !== undefined) {
            video.setAttribute('autoplay', '');
        }
        
        video.load();
        
        if (video.dataset.autoplay !== undefined) {
            video.play().catch(err => {
                console.warn('Autoplay blocked:', err);
            });
        }
    }
});

/* Init
======================================== */
heights();

setTimeout(function(){
    $('#loader').fadeOut();
}, speed);

/* Resize
======================================== */
$(window).on('resize', function() {
    heights();
});